import account from "./account";
import accountMgt from "./accountMgt";
const output = { account, accountMgt };
export default output;
